import { BASE_URL } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  POST: 'PARENT_OTP_POST',
  POST_SUCCESS: 'PARENT_OTP_POST_SUCCESS',
  POST_FAILURE: 'PARENT_OTP_POST_FAILURE',
};

export const post = actions.post(() => `${BASE_URL}/parent-login/`, {
  PENDING: ACTIONS.POST,
  SUCCESS: ACTIONS.POST_SUCCESS,
  FAILURE: ACTIONS.POST_FAILURE,
});
